import { ChatIcon } from './icons';

export function LauncherButton({
  onClick,
  unread = 0
}: {
  onClick: () => void;
  unread?: number;
}) {
  return (
    <button class="launcher" onClick={onClick} aria-label="Open chat">
      <ChatIcon />
      {unread > 0 && (
        <span class="launcher-badge" aria-label={`${unread} unread`}>
          {unread > 9 ? '9+' : unread}
        </span>
      )}
    </button>
  );
}
